import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { safeJsonClone } from '@ebw-monorepo/microservices-helpers/utils/parser';
import { EbwModalService } from '@ebw-monorepo/modal';
import { UtilsService } from '@ebw-monorepo/utils';
import { API_URLS, ApiUrlService } from '../../../../../../../utils/src/lib/services/api-url.service';
import { ShapeStyleModel } from '../../../../models/shape.model';

@Component({
  selector: 'ebw-monorepo-add-layer-style-form',
  templateUrl: './add-layer-style-form.component.html',
  styleUrls: ['./add-layer-style-form.component.scss']
})
export class LayerStyleFormComponent implements OnInit {
  public styleForm: FormGroup;
  public isEdit = false;

  public symbolizers = [];
  public symbolizersFormConfig = {};
  public rules = [];

  public ngForm: NgForm;

  private counter = 1;

  constructor(
    private _ebwModalService: EbwModalService,
    private _utilsService: UtilsService,
    private _i18nService: I18NService,
    public dialogRef: MatDialogRef<LayerStyleFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { shapeStyle?: ShapeStyleModel },
    private _apiUrlService: ApiUrlService
  ) {}

  ngOnInit(): void {
    if (this.data.shapeStyle) {
      this.isEdit = true;
    }

    this.symbolizers = Object.keys(this.stylesConfiguration).filter((el) => el != 'label');
    if (this.symbolizers.length == 0) {
      this.symbolizers = [];
      this._ebwModalService.openErrorModal({
        title: this._i18nService.getInstantValue('common.delete'),
        content: this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.no_symbols')
      });
      return;
    }

    let styleTitle = null;
    if (this.isEdit) {
      styleTitle = this.data.shapeStyle.title;
      this.rules = safeJsonClone(this.data.shapeStyle.rules, []);
      this.rules.forEach((el) => {
        let id = this.counter++;

        el.id = id;

        if (el.label) {
          el.showLabel = true;
          if (typeof el.label.font.value != 'undefined') {
            el.label.label_type = '1';
          }

          if (typeof el.label.font.column != 'undefined') {
            el.label.label_type = '2';
          }

          if (!el.label.halo) {
            el.label.halo = {
              fill: '#000000'
            };
          }
        } else {
          el.showLabel = false;
          el.label = {
            font: {},
            label_type: '2',
            fill: '#000000',
            halo: {
              fill: '#000000'
            }
          };
        }
      });
    }
    this.styleForm = new FormGroup({
      styleTitle: new FormControl(styleTitle, [Validators.required])
    });
  }

  public isRequired(property: string, type: string = null) {
    if (type) {
      switch (type) {
        case 'point':
          switch (property) {
            case 'symbol':
            case 'color':
            case 'size':
            case 'opacity':
              return true;
            default:
              console.log('[REQUIRED] MANCA: TYPE + PROPERTY', property, type);
          }
          break;
        case 'line':
          switch (property) {
            case 'color':
            case 'width':
            case 'opacity':
              return true;
            case 'pattern':
              return false;
            default:
              console.log('[REQUIRED] MANCA: TYPE + PROPERTY', property, type);
          }
          break;
        case 'polygon':
          switch (property) {
            case 'color':
            case 'opacity':
            case 'stroke_color':
            case 'stroke_width':
            case 'stroke_opacity':
              return true;
            default:
              console.log('[REQUIRED] MANCA: TYPE + PROPERTY', property, type);
          }
          break;
        case 'label':
          switch (property) {
            case 'font_color':
            case 'font_family':
            case 'font_weight':
            case 'font_size':
            case 'font_value':
            case 'font_column':
              return true;
            case 'halo_radius':
            case 'halo_color':
              // case "anchor":
              // case "displacement":
              return false;
            default:
              console.log('[REQUIRED] MANCA: TYPE + PROPERTY', property, type);
          }
          break;
        default:
          console.log('[REQUIRED] MANCA: TYPE + PROPERTY', property, type);
      }
    } else {
      switch (property) {
        case 'rule_name':
        case 'type':
          return true;
        case 'maxScale':
        case 'minScale':
          return false;
        default:
          console.log('[REQUIRED] MANCA: PROPERTY', property, type);
      }
    }
    return false;
  }

  public newRule() {
    let id = this.counter++;
    this.rules.push({
      id: id,
      rule_name: 'Nuova regola #' + id,
      color: '#000000',
      size: 4,
      opacity: 1,
      width: 1,
      stroke_width: 1,
      stroke_opacity: 1,
      stroke_color: '#000000',
      showLabel: false,
      label: {
        font: { size: 1 },
        label_type: '2',
        fill: '#000000',
        halo: {
          fill: '#000000'
        }
      }
    });
    return;
  }

  public deleteRule(id) {
    this._ebwModalService
      .openConfirmModal({
        title: this._i18nService.getInstantValue('common.delete'),
        content: this._i18nService.getInstantValue('map.sidebar.shape.style_form.message.delete_rule')
      })
      .afterClosed()
      .subscribe((result) => {
        if (result == true) {
          this.rules.splice(
            this.rules.indexOf((el) => el.id == id),
            1
          );
          return;
        }
      });
  }

  public save() {
    let style = {};
    let body = {
      style: style
    };

    if (!this.validateForm(style)) {
      return;
    }

    if (this.isEdit) {
      this._utilsService.postRequest(this._apiUrlService.createUrl(API_URLS.MAP.LAYER.UPDATE_STYLE), body, false, {}, 'application/json').subscribe({
        next: (value) => {
          this._ebwModalService.openSuccessModal({
            title: this._i18nService.getInstantValue('map.sidebar.shape.style_success'),
            content: ''
          });

          this.dialogRef.close('RELOAD');
        },
        error: (error) => {
          this._ebwModalService.openErrorModal({
            title: this._i18nService.getInstantValue('common.error'),
            content: error?.error?.message
          });
        }
      });
    } else {
      this._utilsService.postRequest(this._apiUrlService.createUrl(API_URLS.MAP.LAYER.ADD_STYLE), body, false, {}, 'application/json').subscribe({
        next: (value) => {
          this._ebwModalService.openSuccessModal({
            title: this._i18nService.getInstantValue('map.sidebar.shape.style_success'),
            content: ''
          });

          this.dialogRef.close('RELOAD');
        },
        error: (error) => {
          this._ebwModalService.openErrorModal({
            title: this._i18nService.getInstantValue('common.error'),
            content: error?.error?.message
          });
        }
      });
    }
  }

  public validateForm(styleObj) {
    if (!this.styleForm.valid) {
      this._ebwModalService.openErrorModal({
        title: this._i18nService.getInstantValue('common.error'),
        content: `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.style_title')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      });
      return false;
    }
    styleObj['title'] = this.styleForm.get('styleTitle').value;

    if (this.rules.length == 0) {
      this._ebwModalService.openErrorModal({
        title: this._i18nService.getInstantValue('common.error'),
        content: `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.no_rules')}`
      });
      return false;
    }

    let checkNames = {};
    this.rules
      .map((el) => el.rule_name)
      .reduce(function (count, element) {
        count[element] = (count[element] || 0) + 1;
        return count;
      }, checkNames);

    let duplicate = Object.keys(checkNames).filter((el) => {
      return checkNames[el] > 1;
    });

    if (duplicate.length > 0) {
      this._ebwModalService.openErrorModal({
        title: this._i18nService.getInstantValue('common.error'),
        content: `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.duplicated_names')}`
      });
      return false;
    }

    styleObj['rules'] = [];

    let errors = [];
    this.rules.forEach((rule) => {
      let str = '';
      let ruleObj = {};
      switch (rule.type) {
        case 'point':
          let validationPoint = this.validatePoint(rule, ruleObj);
          if (validationPoint.length > 0) {
            str = `${rule.rule_name}:\n${validationPoint.join()}`;
          }
          if (rule.showLabel) {
            let validationLabel = this.validateLabel(rule, ruleObj);
            if (validationLabel.length > 0) {
              str += `\nLabel:${validationLabel.join()}`;
            }
          }
          if (str.length > 0) {
            errors.push(str);
          }
          break;
        case 'line':
          let validationLine = this.validateLine(rule, ruleObj);
          if (validationLine.length > 0) {
            str = `${rule.rule_name}:\n${validationLine.join()}`;
          }
          if (rule.showLabel) {
            let validationLabel = this.validateLabel(rule, ruleObj);
            if (validationLabel.length > 0) {
              str += `\nLabel:${validationLabel.join()}`;
            }
          }
          if (str.length > 0) {
            errors.push(str);
          }
          break;
        case 'polygon':
          let validationPolygon = this.validatePolygon(rule, ruleObj);
          if (validationPolygon.length > 0) {
            str = `${rule.rule_name}:\n${validationPolygon.join()}`;
          }
          if (rule.showLabel) {
            let validationLabel = this.validateLabel(rule, ruleObj);
            if (validationLabel.length > 0) {
              str += `\nLabel:${validationLabel.join()}`;
            }
          }
          if (str.length > 0) {
            errors.push(str);
          }
          break;
        default:
          errors.push(
            `${rule.rule_name}:\n${this._i18nService.getInstantValue(
              'map.sidebar.shape.style_form.rule_symbolizer'
            )} ${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.not_valid')}`
          );
      }

      styleObj['rules'].push(ruleObj);
    });

    if (errors.length > 0) {
      this._ebwModalService.openErrorModal({
        title: this._i18nService.getInstantValue('common.error'),
        content: errors.join('\n')
      });
      return false;
    }

    return true;
  }

  public validatePoint(rule, ruleObj) {
    let rule_errors = [];

    if (!this.isValid(rule.rule_name, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_name')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (!this.isValid(rule.type, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_symbolizer')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (typeof rule.symbol == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.pointSymbol')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    if (typeof rule.size == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.size')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    ruleObj['type'] = rule.type;
    ruleObj['rule_name'] = rule.rule_name;
    ruleObj['symbol'] = rule.symbol;
    ruleObj['size'] = rule.size;
    ruleObj['color'] = rule.color;
    ruleObj['opacity'] = rule.opacity;

    if (typeof rule.minScale != 'undefined' && rule.minScale != 0) {
      ruleObj['minScale'] = rule.minScale;
    }

    if (typeof rule.maxScale != 'undefined' && rule.maxScale != 0) {
      ruleObj['maxScale'] = rule.maxScale;
    }

    if (ruleObj['maxScale'] && ruleObj['minScale']) {
      if (ruleObj['maxScale'] <= ruleObj['minScale']) {
        rule_errors.push(`${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.scale_ratio')}`);
      }
    }

    return rule_errors;
  }

  public validateLine(rule, ruleObj) {
    let rule_errors = [];

    if (!this.isValid(rule.rule_name, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_name')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (!this.isValid(rule.type, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_symbolizer')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (!!rule.pattern) {
      if (!this.isValid(rule.pattern, 'pattern')) {
        rule_errors.push(
          `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.stroke_pattern')} ${this._i18nService.getInstantValue(
            'map.sidebar.shape.style_form.errors.not_valid'
          )}`
        );
      } else {
        ruleObj['pattern'] = rule.pattern;
      }
    }

    if (typeof rule.width == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.stroke_width')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    ruleObj['type'] = rule.type;
    ruleObj['rule_name'] = rule.rule_name;
    ruleObj['width'] = rule.width;
    ruleObj['color'] = rule.color;
    ruleObj['opacity'] = rule.opacity;

    if (typeof rule.minScale != 'undefined' && rule.minScale != 0) {
      ruleObj['minScale'] = rule.minScale;
    }

    if (typeof rule.maxScale != 'undefined' && rule.maxScale != 0) {
      ruleObj['maxScale'] = rule.maxScale;
    }

    if (ruleObj['maxScale'] && ruleObj['minScale']) {
      if (ruleObj['maxScale'] <= ruleObj['minScale']) {
        rule_errors.push(`${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.scale_ratio')}`);
      }
    }

    return rule_errors;
  }

  public validatePolygon(rule, ruleObj) {
    let rule_errors = [];

    if (!this.isValid(rule.rule_name, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_name')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (!this.isValid(rule.type, 'string')) {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.rule_symbolizer')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.not_valid'
        )}`
      );
    }

    if (typeof rule.stroke_width == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.stroke_width')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    ruleObj['type'] = rule.type;
    ruleObj['rule_name'] = rule.rule_name;
    ruleObj['color'] = rule.color;
    ruleObj['opacity'] = rule.opacity;
    ruleObj['stroke_color'] = rule.stroke_color;
    ruleObj['stroke_opacity'] = rule.stroke_opacity;
    ruleObj['stroke_width'] = rule.stroke_width;

    if (typeof rule.minScale != 'undefined' && rule.minScale != 0) {
      ruleObj['minScale'] = rule.minScale;
    }

    if (typeof rule.maxScale != 'undefined' && rule.maxScale != 0) {
      ruleObj['maxScale'] = rule.maxScale;
    }

    if (ruleObj['maxScale'] && ruleObj['minScale']) {
      if (ruleObj['maxScale'] <= ruleObj['minScale']) {
        rule_errors.push(`${this._i18nService.getInstantValue('map.sidebar.shape.style_form.errors.scale_ratio')}`);
      }
    }

    return rule_errors;
  }

  public validateLabel(rule, ruleObj) {
    let rule_errors = [];

    if (typeof rule.label.font.family == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.font_family')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    if (typeof rule.label.font.size == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.size')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    if (typeof rule.label.font.weight == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.font_weight')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    }

    if (typeof rule.label.label_type == 'undefined') {
      rule_errors.push(
        `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.label_type')} ${this._i18nService.getInstantValue(
          'map.sidebar.shape.style_form.errors.missing'
        )}`
      );
    } else {
      if (rule.label.label_type == '1' && typeof rule.label.font.value == 'undefined') {
        rule_errors.push(
          `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.label_text')} ${this._i18nService.getInstantValue(
            'map.sidebar.shape.style_form.errors.missing'
          )}`
        );
      }

      if (rule.label.label_type == '2' && typeof rule.label.font.column == 'undefined') {
        rule_errors.push(
          `${this._i18nService.getInstantValue('map.sidebar.shape.style_form.label_column')} ${this._i18nService.getInstantValue(
            'map.sidebar.shape.style_form.errors.missing'
          )}`
        );
      }
    }

    ruleObj['label'] = {
      font: {
        family: rule.label.font.family,
        size: rule.label.font.size,
        weight: rule.label.font.weight
      },
      fill: rule.label.fill
    };

    if (rule.label.label_type == '1') {
      ruleObj['label']['font']['value'] = rule.label.font.value;
    }

    if (rule.label.label_type == '2') {
      ruleObj['label']['font']['column'] = rule.label.font.column;
    }

    if (typeof rule.label.halo.radius != 'undefined') {
      ruleObj['label']['halo'] = {
        radius: rule.label.halo.radius,
        fill: rule.label.halo.fill
      };
    }

    return rule_errors;
  }

  public isValid(value, type) {
    switch (type) {
      case 'string':
        return value != null && typeof value != 'undefined' && typeof value === 'string' && value.trim().length > 0;
      case 'pattern':
        return (
          value != null &&
          typeof value != 'undefined' &&
          typeof value === 'string' &&
          value.trim().length > 0 &&
          value.split(',').every((part: string) => /^\d+$/.test(part))
        );
      case 'hexColor':
        return (
          value != null &&
          typeof value != 'undefined' &&
          typeof value === 'string' &&
          value.trim().length > 0 &&
          // fixed-length bounded regex — no catastrophic backtracking, not ReDoS-prone
          // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
          /^#[A-Fa-f0-9]{3}([A-Fa-f0-9]{3})?$/.test(value)
        );
      case 'number':
        return typeof value === 'number' && !isNaN(value);
      default:
        return false;
    }
  }

  stylesConfiguration = {
    point: {
      symbol: {
        labels: [/*'Square',*/ 'Circle', 'Triangle', 'Star', 'Cross', 'X'],
        values: [/*'square',*/ 'circle', 'triangle', 'star', 'cross', 'x']
      }
    },
    line: {},
    polygon: {},
    label: {
      font: {
        family: {
          lables: ['Arial', 'Times New Roman', 'Courier New'],
          values: ['Arial', 'Times New Roman', 'Courier New']
        },
        weight: {
          labels: ['Normal', 'Bold'],
          values: ['normal', 'bold']
        }
      }
    }
  };
}
